import React from 'react'
import PropTypes, { number, string } from 'prop-types'

const ViFlagIcon = ({ size = '36' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24C0 26.2091 1.79086 28 4 28H24C26.2091 28 28 26.2091 28 24V4C28 1.79086 26.2091 0 24 0H4C1.79086 0 0 1.79086 0 4V24Z"
        fill="#F90805"
      />
      <path
        d="M13.8593 7.28027L15.4058 12.3172L20.4393 12.3037L16.3611 15.4078L17.9247 20.4403L13.8593 17.3226L9.79392 20.4403L11.3575 15.4078L7.2793 12.3037L12.3128 12.3172L13.8593 7.28027Z"
        fill="#FEDC36"
      />
    </svg>
  )
}

export default React.memo(ViFlagIcon)

ViFlagIcon.propTypes = {
  size: PropTypes.oneOfType([string, number]),
}
